import { publicRequest } from "../core/services";
const homepage = {
    section: (data) => publicRequest.post("/api/homepage/get-homepage-sections", data),
};
export const api = {
    homepage,
};
